import React from 'react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
type ButtonVariant = 'primary' | 'secondary' | 'inverse';
interface ButtonLinkProps {
  to: string;
  children: ReactNode;
  variant?: ButtonVariant;
  className?: string;
}
const variantClasses: Record<ButtonVariant, string> = {
  primary: 'bg-ink text-white border border-ink hover:bg-[#262626] hover:border-[#262626]',
  secondary: 'bg-canvas text-ink border border-hairline hover:border-ink',
  inverse: 'bg-white text-ink border border-white hover:bg-[#EDEDEA] hover:border-[#EDEDEA]'
};
export function ButtonLink({
  to,
  children,
  variant = 'primary',
  className = ''
}: ButtonLinkProps) {
  const classes = `inline-flex h-12 items-center justify-center rounded-card px-6 text-small font-medium transition-colors duration-150 ease-out ${variantClasses[variant]} ${className}`;
  if (to.startsWith('http') || to.startsWith('mailto:') || to.startsWith('tel:')) {
    return <a href={to} className={classes} data-id="element-101" data-mp="2ck9ive22zili">
        {children}
      </a>;
  }
  return <Link to={to} className={classes} data-id="element-102" data-mp="ags9q3vrgfu5">
      {children}
    </Link>;
}